/**
 * Franse EUR-notatie voor formatMoney (alleen ingeladen bij fr-taal in layout).
 * Duizendtallen: spatie; decimalen: komma; euroteken na vaste NBSP.
 */
(function () {
  function formatFrenchEUR(cents) {
    cents = Math.round(Number(cents));
    var neg = cents < 0;
    var c = Math.abs(cents);
    var intp = Math.floor(c / 100);
    var dec = String(c % 100).padStart(2, '0');
    var intStr = String(intp);
    var grouped = intStr.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return (neg ? '-' : '') + grouped + ',' + dec + '\u00a0€';
  }

  var orig = typeof window.formatMoney === 'function' ? window.formatMoney : null;
  if (!orig) return;

  window.formatMoney = function (cents, format) {
    return formatFrenchEUR(cents);
  };
})();
